import { customElement } from 'lit/decorators.js';
import { localized } from "@lit/localize";
import { UsosBox } from "./usos-box";
import commonStyle from './usos-box.scss';
import style from './info-box.scss';

/**
 * Neutral box information.
 */

@customElement('info-box')
@localized()
export class InfoBox extends UsosBox {
    static override styles = [commonStyle, style];
}

declare global {
    interface HTMLElementTagNameMap {
        'info-box': InfoBox
    }
}